module.exports = __webpack_public_path__ + "img/user.5dbdfd8f.png";